<template>
	<LayoutList>
		<template slot="header">
			<h1>Users</h1>
			<router-link to="/users/create" class="btn btn--primary" v-if="can('createUsers')">Users Setup</router-link>
		</template>

		<template slot="filters">
			<FormControlSector name="sectors" v-model="filters.sectors" :multiple="true" :include-ancestors="false">
			</FormControlSector>
			<FormControlMember name="member" v-model="filters.member" placeholder="Select..."></FormControlMember>
		</template>

		<div class="form__group search" slot="search">
			<label for="local-search" class="form__label">Search Users</label>
			<input id="local-search" class="form__control search" type="search" placeholder="Search Users..."
			       v-model="filters.query" />
		</div>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="all" title="All Users">
				<ListUsers ref="all" :load-on-start="false" :filters="filters"></ListUsers>
			</v-tab>
			<v-tab id="inactive" title="Never Active">
				<ListUsers ref="inactive" :inactive-only="true" :load-on-start="false" :filters="filters"></ListUsers>
			</v-tab>
			<v-tab id="suspended" title="Suspended Users">
				<ListUsers ref="suspended" :suspended-only="true" :load-on-start="false" :filters="filters"></ListUsers>
			</v-tab>
		</vue-tabs>
	</LayoutList>
</template>

<script>
	import { mapGetters } from 'vuex';
	import LayoutList from '../Layout/LayoutList';
	import ListUsers from '../List/ListUsers';
	import FormControlSector from '../Form/Control/FormControlSector';
	import FormControlCategory from '../Form/Control/FormControlCategory';
	import FormControlMember from '../Form/Control/FormControlMember';
	import TabbedPage from '../TabbedPage';

	export default {
		name: 'UserList',
		mixins: [TabbedPage],
		components: {
			FormControlMember,
			FormControlCategory,
			FormControlSector,
			ListUsers,
			LayoutList,
		},
		data() {
			return {
				filters: {
					sectors: [],
					member: null,
					query: null,
				},
				defaultTab: 'all',
				tabRoute: 'users',
			}
		},
		computed: {
			...mapGetters([
				'can',
			]),
		},
	}
</script>
